import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import { axisClasses } from '@mui/x-charts';

const columns = [
    { id: 'RowNum', label: 'Sr.No', minWidth: 170 },
    { id: 'FoodClsName', label: 'FoodClassName', minWidth: 170 },
    { id: 'Abrv', label: 'Abrv', minWidth: 170 },
    { id: 'Remark', label: 'Remark', minWidth: 170 },
];

const FoodClass = () => {

    const [formData, setFormData] = useState({
        FoodClsName: '',
        Abrv: '',
        Remark: ''
    });
    const [error, setError] = useState({
        FoodClass: false,
        FoodAbvr: false
    });
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [currentClsId, setCurrentClsId] = useState(null);
    const [lastInsertedId, setLastInsertedId] = useState(null);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const location = useLocation();
    const navigate = useNavigate();
    const foodClassRef = useRef(null);
    const foodAbrvRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.FoodClsId) {
            setCurrentClsId(location.state.FoodClsId);
            fetchFoodClass(location.state.FoodClsId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location])

    const fetchFoodClass = async (id, flag) => {

        try {
            const response = await axiosInstance.post(`MstFoodCls/RetriveMstFoodCls`, {
                FoodClsId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const foodData = response.data.Data[0];
                setFormData({
                    FoodClsName: foodData.FoodClsName,
                    Abrv: foodData.Abrv,
                    Remark: foodData.Remark
                });
                setStatus(foodData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentClsId(foodData.FoodClsId);
            }
        } catch (error) {
            toast.error('Error fetching food class data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('MstFoodCls/GetMstFoodClsDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                })

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (error) {
                toast.error("Error while printing the data.")
            }
        };
        getRow();
    }, [])

    const handlePrevious = async () => {
        if (currentClsId && currentClsId > 1) {
            await fetchFoodClass(currentClsId, "P");
        }
    };

    const handleNext = async () => {
        if (currentClsId) {
            await fetchFoodClass(currentClsId, "N");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.target === foodClassRef.current) {
                foodAbrvRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            FoodClsName: '',
            Abrv: '',
            Remark: ''
        });
        setCurrentClsId(null);
        setTimeout(() => {
            foodClassRef.current.focus();
        }, 0);
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentClsId, 'MstFoodCls', 'FoodClsId');
        switch (Flag) {
            case 0:
                setMode('edit');
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record alredy locked", { autoClose: 500 });
                break;
            default:
                toast.info('Something went wrong', { autoClose: 500 })
        }
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmDelete = async () => {
        try {
            let Flag = await checkAndLock(currentClsId, 'MstFoodCls', 'FoodClsId');

            switch (Flag) {
                case 0:
                    setOpenConfirmDialog(false);

                    const response = await axiosInstance.post('MstFoodCls/DeleteMstFoodCls', {
                        FoodClsId: currentClsId
                    });

                    // Handle API response for deletion
                    if (response.data.Status === 0) {
                        toast.success(response.data.Message || 'Record deleted.');
                        await fetchFoodClass(currentClsId, "P");
                        setStatus("1");
                        setMode('view');
                        setIsFormDisabled(true);
                    } else {
                        toast.warn(response.data.Message || "Failed to delete the record.");
                    }
                    break;

                case 1:
                    toast.info("Record already locked", { autoClose: 500 });
                    break;
                case 2:
                    toast.info("Record failed to lock", { autoClose: 500 });
                    break;
                default:
                    toast.info("Something went wrong", { autoClose: 500 });
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.", { autoClose: 500 });
        }
    };

    const handleExit = () => {
        navigate('/foodclstable');
    };

    const handleSubmit = async () => {
        let hasError = false;
        if (!formData.FoodClsName) {
            toast.error('Food class is required.');
            setError(prev => ({ ...prev, FoodClsName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, FoodClsName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                FoodClsName: formData.FoodClsName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                Status: Status
            };
            let response;
            if (mode === 'edit') {
                payload.FoodClsId = currentClsId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFoodCls/UpdateMstFoodCls', payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFoodCls/InsertMstFoodCls', payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedId(response.data.Data)
                    await fetchFoodClass(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentClsId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.info(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error("Error while saving.");
        }
    };

    const handleCancel = async () => {
        try {
            await fetchFoodClass(1, "L");
            await UnLock(currentClsId, 'MstFoodCls', 'FoodClsId');
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error while canceling.");
        }
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    return (
        <>
            <Box className='form-container' sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' } }}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF' }}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant='h5'
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Food Class Master
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName={"Food Class Master"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id='FoodClsName'
                                    name='FoodClsName'
                                    label={<span>Food Class<span style={{ color: 'red' }}>*</span></span>}
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.FoodClsName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodClassRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id='Abrv'
                                    name='Abrv'
                                    label='Abrv'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodAbrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={10}>
                                <TextField
                                    id='Remark'
                                    name='Remark'
                                    label='Remark'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label='Status'
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_button'>
                        {mode === 'view' && (
                            <>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                                    Cancel
                                </Button>
                            </>
                        )}

                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title='Food Class Master'
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby='alert-dialog-title'
                area-describedby='alert-dialog-description'
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Are you sure want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button sx={{
                        backgroundColor: '#635BFF',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#1565c0',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button sx={{
                        backgroundColor: '#635BFF',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#1565c0',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FoodClass;